import axios from "axios";
// import airbrake from "@/logging/logging";
import config from "@/logging/config";

const httpCustomRedirectHeader = "x-message-redirect";
const simplePaymentsPatientHttpClient = axios.create({
  baseURL: "/api",
  headers: {
    "Correlation-Id": config._sessionId,
  },
});

const handleErrorResponse = (error) => {
  let {
    response: { status: errorCode },
  } = error;
  if (401 === errorCode) {
    let {
      response: {
        headers: { [httpCustomRedirectHeader]: redirect },
      },
    } = error;
    if (redirect) {
      window.location.href = redirect;
      return Promise.reject({ ...error, isForwarding: true });
    } else {
      let msg = "Unknown Error";
      /* airbrake.notify({
              error,
              message: msg
            }); */
      console.error(msg);
    }
  }

  return Promise.reject(error);
};

simplePaymentsPatientHttpClient.interceptors.response.use(
  (response) => {
    //store.dispatch(
    // TODO: SessionExpiration component and all that jazz?
    // ActionType.general.SET_SESSION_EXPIRES,
    // moment().add(15, "m")
    //);
    return response;
  },
  (error) => {
    //  https://github.com/axios/axios#handling-errors
    if (error.response) {
      return handleErrorResponse(error);
    } else if (error.request) {
      let msg = "The request was made, but no response was received";
      /*airbrake.notify({
              error,
              message: msg
            }); */
      console.error(msg);
      return Promise.reject(error);
    } else {
      let msg =
        "Something happened in setting up the request that triggered an Error";
      /*airbrake.notify({
              error,
              message: msg
            });*/
      console.error(msg);
      return Promise.reject(error);
    }
  }
);

export { simplePaymentsPatientHttpClient };
